import { RDIrrigation } from '@cibo/core'
import { Divider, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TraitCellDisplayProps } from '../types'

export const IrrigationCell = ({ traitId, year, params }: TraitCellDisplayProps<RDIrrigation>) => {
  const { t } = useTranslation('@cibo/landmanager/IrrigationEditor')
  const detail = params.row.findDetail({ traitId, year })
  const input = detail?.input

  return (
    <Stack>
      <Typography>
        {!detail?.result
          ? t('no')
          : !!input?.rate && input.units
          ? `${input.rate} ${t('unit', { context: input.units })}`
          : t('yes')}
      </Typography>

      <Stack direction="row" spacing={1} divider={<Divider orientation="vertical" flexItem />}>
        {!!input?.irrigationType && (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {t('type', { context: input.irrigationType })}
          </Typography>
        )}
        {!!input?.schedule && (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {t('schedule', { context: input.schedule })}
          </Typography>
        )}
      </Stack>
    </Stack>
  )
}
